export function displayPhone(phone: string | null | undefined): string {
  if (!phone) return "";
  if (phone.length === 10 && /^\d+$/.test(phone)) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  return phone;
}
